.text {
  color: var(--color-grayscale-light-slate);
}

.confirm-label {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin-top: 1.2rem;
  cursor: pointer;
  color: var(--color-grayscale-light-slate);
  font-size: 1.4rem;

  input[type='checkbox'] {
    margin-top: 0.2rem;
    cursor: pointer;
  }
}
